// start:ng42.barrel
import './organisation-list.component';
// end:ng42.barrel

